module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/rubber-dam.ba8f6afc.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/rubber-dam.png
// module id = 223
// module chunks = 0